import React from "react";
import "@assets/scss/intel.scss";
import "@assets/scss/global.scss";
import Card from "react-bootstrap/Card";
import Accordion from "react-bootstrap/Accordion";
import { ChevronDown, X } from "react-feather";
import { toast } from "react-toastify";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import Button from "@components/base/button";
const emptyShipment = { min: -1, max: -1 };
const emptyWeight = { min: -1, max: -1 };
const emptyTeu = { min: -1, max: -1 };
const emptyValue = { min: -1, max: -1 };
const filterKeywords = {
  weight: "WEIGHT",
  shipment: "SHIPMENT",
  teu: "TEU",
  value: "VALUE",
};
const SORTING_PRIORITY = [
  { key: "uniqueImportExporterValue", sortKey: "shipment_value" },
  { key: "uniqueImportExporterTeu", sortKey: "teu" },
  { key: "uniqueImportExporterWeight", sortKey: "weight" },
  { key: "uniqueImportExporterShipment", sortKey: "date" },
];

export default class EmptySavedSearch extends React.Component {
  constructor(props) {
    super(props);
    this.dropdownRef = React.createRef();
  }
  state = {
    isShipmentVisible: false,
    isValueVisible: false,
    isWeightVisible: false,
    isTeuVisible: false,
    isOpen: false,
    shipment: {
      min: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.shipment.min : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.shipment.min : -1,
      max: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.shipment.max : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.shipment.max : -1,
    },
    weight: {
      min: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.weight.min : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.weight.min : -1,
      max: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.weight.max : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.weight.max : -1,
    },
    teu: {
      min: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.teu.min : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.teu.min : -1,
      max: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.teu.max : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.teu.max : -1,
    },
    value: {
      min: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.value.min : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.value.min : -1,
      max: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.value.max : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.value.max : -1,
    },
    filterAppliedShipment: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.filterAppliedShipment : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.filterAppliedShipment : false,
    filterAppliedTeu: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.filterAppliedTeu : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.filterAppliedTeu : false,
    filterAppliedValue: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.filterAppliedValue : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.filterAppliedValue : false,
    filterAppliedWeight: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.filterAppliedWeight : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.filterAppliedWeight : false,
    uniqueImportExporterShipment: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.uniqueImportExporterShipment : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.uniqueImportExporterShipment : [],
    uniqueImportExporterTeu: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.uniqueImportExporterTeu : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.uniqueImportExporterTeu : [],
    uniqueImportExporterValue: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.uniqueImportExporterValue : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.uniqueImportExporterValue : [],
    uniqueImportExporterWeight: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.uniqueImportExporterWeight : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.uniqueImportExporterWeight : [],
    count: !!this.props && !!this.props.importerData && this.props.importerData !== "" && this.props.type === "IMPORTER" ? this.props.importerData.count : !!this.props && !!this.props.exporterData && this.props.type === "EXPORTER" ? this.props.exporterData.count : 0,
    shipmentType: "less",
    valueType: "less",
    weightType: "less",
    teuType: "less",
  };
  componentDidMount() {
    this.checkVisiblity();
    if (this.props?.importerData?.filterAppliedShipment || this.props?.exporterData?.filterAppliedShipment) {
      this.setState({
        shipmentType: this.props.importerData ? this.props.importerData.shipmentType : this.props.exporterData ? this.props.exporterData.shipmentType : "less",
      });
    }
    if (this.props?.importerData?.filterAppliedTeu || this.props?.exporterData?.filterAppliedTeu) {
      this.setState({
        teuType: this.props.importerData ? this.props.importerData.teuType : this.props.exporterData ? this.props.exporterData.teuType : "less",
      });
    }
    if (this.props?.importerData?.filterAppliedValue || this.props?.exporterData?.filterAppliedValue) {
      this.setState({
        valueType: this.props.importerData ? this.props.importerData.valueType : this.props.exporterData ? this.props.exporterData.valueType : "less",
      });
    }
    if (this.props?.importerData?.filterAppliedWeight || this.props?.exporterData?.filterAppliedWeight) {
      this.setState({
        weightType: this.props.importerData ? this.props.importerData.weightType : this.props.exporterData ? this.props.exporterData.weightType : "less",
      });
    }
    window.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    window.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.state.isOpen && this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };

  onClickHandler = (event) => {
    event.stopPropagation();
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));

    if (!this.state.isOpen && this.props.type) {
      if (this.props.type === "IMPORTER") {
        this.props.callingPendoEvent(trackingEventDictionary.uniqueImportersTabInternalFilterOpen);
      } else {
        this.props.callingPendoEvent(trackingEventDictionary.uniqueExportersTabInternalFilterOpen);
      }
    }
  };

  determineSortingStrategy = (internalFilters) => {
    for (const field of SORTING_PRIORITY) {
      const filter = internalFilters[field.key];
      if (filter && filter.length > 0) {
        return {
          sort: field.sortKey,
          order: (filter[0] === -1 && filter[1] > -1) || (filter[0] !== -1 && filter[1] !== -1) ? "desc" : "asc",
        };
      }
    }
    return { sort: null, order: null };
  };

  bindWeight = (data, type) => {
    const tempWeight = this.state.weight;
    if (type === "min" && !data) {
      tempWeight.max = -1;
      this.setState({ filterAppliedWeight: false });
    } else if (type === "min") {
      tempWeight.max = data;
      this.setState({ filterAppliedWeight: true });
    }
    if (type === "max" && !data) {
      tempWeight.min = -1;
      this.setState({ filterAppliedWeight: false });
    } else if (type === "max") {
      tempWeight.min = data;
      this.setState({ filterAppliedWeight: true });
    }
    this.setState({
      weight: tempWeight,
    });
  };
  bindShipment = (data, type) => {
    const tempShipment = this.state.shipment;
    if (type === "min" && !data) {
      tempShipment.max = -1;
      this.setState({ filterAppliedShipment: false });
    } else if (type === "min") {
      tempShipment.max = data;
      this.setState({ filterAppliedShipment: true });
    }
    if (type === "max" && !data) {
      tempShipment.min = -1;
      this.setState({ filterAppliedShipment: false });
    } else if (type === "max") {
      tempShipment.min = data;
      this.setState({ filterAppliedShipment: true });
    }
    this.setState({
      shipment: tempShipment,
    });
  };
  bindTeu = (data, type) => {
    const tempTeu = this.state.teu;
    if (type === "min" && !data) {
      tempTeu.max = -1;
      this.setState({ filterAppliedTeu: false });
    } else if (type === "min") {
      tempTeu.max = data;
      this.setState({ filterAppliedTeu: true });
    }
    if (type === "max" && !data) {
      tempTeu.min = -1;
      this.setState({ filterAppliedTeu: false });
    } else if (type === "max") {
      tempTeu.min = data;
      this.setState({ filterAppliedTeu: true });
    }
    this.setState({
      teu: tempTeu,
    });
  };
  bindValue = (data, type) => {
    const tempValue = this.state.value;
    if (type === "min" && !data) {
      tempValue.max = -1;
      this.setState({ filterAppliedValue: false });
    } else if (type === "min") {
      tempValue.max = data;
      this.setState({ filterAppliedValue: true });
    }
    if (type === "max" && !data) {
      tempValue.min = -1;
      this.setState({ filterAppliedValue: false });
    } else if (type === "max") {
      tempValue.min = data;
      this.setState({ filterAppliedValue: true });
    }
    this.setState({
      value: tempValue,
    });
  };

  displayWeight(type) {
    let temp = { ...emptyWeight };
    if (this.props?.type === "IMPORTER" && this.props?.importerData?.filterAppliedWeight && type === this.props?.importerData?.weightType && this.props?.importerData?.weight) {
      temp = { ...this.props.importerData.weight };
    } else if (this.props?.type === "EXPORTER" && this.props?.exporterData?.filterAppliedWeight && type === this.props?.exporterData?.weightType && this.props?.exporterData?.weight) {
      temp = { ...this.props.exporterData.weight };
    }
    this.setState({
      weight: temp,
      filterAppliedWeight: false,
      weightType: type,
    });
  }
  displayTeu(type) {
    let temp = { ...emptyTeu };
    if (this.props?.type === "IMPORTER" && this.props?.importerData?.filterAppliedTeu && type === this.props?.importerData?.teuType && this.props?.importerData?.teu) {
      temp = { ...this.props.importerData.teu };
    } else if (this.props?.type === "EXPORTER" && this.props?.exporterData?.filterAppliedTeu && type === this.props?.exporterData?.teuType && this.props?.exporterData?.teu) {
      temp = { ...this.props.exporterData.teu };
    }
    this.setState({
      teu: temp,
      filterAppliedTeu: false,
      teuType: type,
    });
  }
  displayValue(type) {
    let temp = { ...emptyValue };
    if (this.props?.type === "IMPORTER" && this.props?.importerData?.filterAppliedValue && type === this.props?.importerData?.valueType && this.props?.importerData?.value) {
      temp = { ...this.props.importerData.value };
    } else if (this.props?.type === "EXPORTER" && this.props?.exporterData?.filterAppliedValue && type === this.props?.exporterData?.valueType && this.props?.exporterData?.value) {
      temp = { ...this.props.exporterData.value };
    }
    this.setState({
      value: temp,
      filterAppliedValue: false,
      valueType: type,
    });
  }
  displayShipment(type) {
    let temp = { ...emptyShipment };
    if (this.props?.type === "IMPORTER" && this.props?.importerData?.filterAppliedShipment && type === this.props?.importerData?.shipmentType && this.props?.importerData?.shipment) {
      temp = { ...this.props.importerData.shipment };
    } else if (this.props?.type === "EXPORTER" && this.props?.exporterData?.filterAppliedShipment && type === this.props?.exporterData?.shipmentType && this.props?.exporterData?.shipment) {
      temp = { ...this.props.exporterData.shipment };
    }
    this.setState({
      shipment: temp,
      filterAppliedShipment: false,
      shipmentType: type,
    });
  }
  resetValues(e) {
    let tempShipment = { ...emptyShipment };
    let tempWeight = { ...emptyWeight };
    let tempTeu = { ...emptyTeu };
    let tempValue = { ...emptyValue };
    this.props.clearFilter();
    document.getElementById("onClickClear").classList.remove("show");
    document.getElementById("onClickClear2").classList.remove("show");
    this.setState({
      shipment: tempShipment,
      weight: tempWeight,
      teu: tempTeu,
      value: tempValue,
      filterAppliedShipment: false,
      filterAppliedTeu: false,
      filterAppliedValue: false,
      filterAppliedWeight: false,
      uniqueImportExporterShipment: [],
      uniqueImportExporterTeu: [],
      uniqueImportExporterValue: [],
      uniqueImportExporterWeight: [],
      count: 0,
    });
    if (this.props.type === "IMPORTER") {
      this.props.callingPendoEvent(trackingEventDictionary.uniqueImportersTabFilterByCancel);
    } else {
      this.props.callingPendoEvent(trackingEventDictionary.uniqueExportersTabFilterByCancel);
    }
    setTimeout(() => {
      this.applyFilterFunction(e);
    }, 100);
  }
  clearIndividualFilter(e, data) {
    let tempShipment = { ...emptyShipment };
    let tempWeight = { ...emptyWeight };
    let tempTeu = { ...emptyTeu };
    let tempValue = { ...emptyValue };
    if (data === filterKeywords.shipment) {
      this.setState({ uniqueImportExporterShipment: [], shipment: tempShipment, filterAppliedShipment: false });
    } else if (data === filterKeywords.teu) {
      this.setState({ uniqueImportExporterTeu: [], teu: tempTeu, filterAppliedTeu: false });
    } else if (data === filterKeywords.value) {
      this.setState({ uniqueImportExporterValue: [], value: tempValue, filterAppliedValue: false });
    } else if (data === filterKeywords.weight) {
      this.setState({ uniqueImportExporterWeight: [], weight: tempWeight, filterAppliedWeight: false });
    }
    setTimeout(() => {
      this.applyFilterFunction(e);
    }, 100);
  }
  applyFilterFunction = (e) => {
    e.stopPropagation();
    let input = document.getElementById("dropdownMenuButton");

    let tempShipment = this.state.shipment;
    let tempWeight = this.state.weight;
    let tempTeu = this.state.teu;
    let tempValue = this.state.value;
    let tempShipmentArr = [];
    let tempWeightArr = [];
    let tempTeuArr = [];
    let tempValueArr = [];
    document.getElementById("onClickClear").classList.remove("show");
    document.getElementById("onClickClear2").classList.remove("show");
    if (tempShipment.min !== -1 && tempShipment.max !== -1 && parseInt(tempShipment.max) < parseInt(tempShipment.min)) {
      toast.error("TO value must be greater than FROM value");
      return false;
    }
    if (tempWeight.min !== -1 && tempWeight.max !== -1 && parseInt(tempWeight.max) < parseInt(tempWeight.min)) {
      toast.error("TO value must be greater than FROM value");
      return false;
    }
    if (tempTeu.min !== -1 && tempTeu.max !== -1 && parseInt(tempTeu.max) < parseInt(tempTeu.min)) {
      toast.error("TO value must be greater than FROM value");
      return false;
    }
    if (tempValue.min !== -1 && tempValue.max !== -1 && parseInt(tempValue.max) < parseInt(tempValue.min)) {
      toast.error("TO value must be greater than FROM value");
      return false;
    }
    if (tempShipment.min !== -1 || tempShipment.max !== -1) {
      tempShipmentArr.push(parseInt(tempShipment.min));
      tempShipmentArr.push(parseInt(tempShipment.max));
      this.setState({ uniqueImportExporterShipment: tempShipmentArr });
    }
    if (tempWeight.min !== -1 || tempWeight.max !== -1) {
      tempWeightArr.push(parseInt(tempWeight.min));
      tempWeightArr.push(parseInt(tempWeight.max));
      this.setState({ uniqueImportExporterWeight: tempWeightArr });
    }
    if (tempTeu.min !== -1 || tempTeu.max !== -1) {
      tempTeuArr.push(parseInt(tempTeu.min));
      tempTeuArr.push(parseInt(tempTeu.max));
      this.setState({ uniqueImportExporterTeu: tempTeuArr });
    }
    if (tempValue.min !== -1 || tempValue.max !== -1) {
      tempValueArr.push(parseInt(tempValue.min));
      tempValueArr.push(parseInt(tempValue.max));
      this.setState({ uniqueImportExporterValue: tempValueArr });
    }
    this.setState({ count: (this.state.uniqueImportExporterShipment.length + this.state.uniqueImportExporterWeight.length + this.state.uniqueImportExporterTeu.length + this.state.uniqueImportExporterValue.length) / 2 });
    setTimeout(() => {
      const tempObject = {
        uniqueImportExporterShipment: this.state.uniqueImportExporterShipment,
        uniqueImportExporterWeight: this.state.uniqueImportExporterWeight,
        uniqueImportExporterTeu: this.state.uniqueImportExporterTeu,
        uniqueImportExporterValue: this.state.uniqueImportExporterValue,
      };
      const { sort, order } = this.determineSortingStrategy(tempObject);
      tempObject.sort_key = sort;
      tempObject.sort_order = order;
      this.setTotalFilterCount();
      this.props.sendingDataToSearch(tempObject);
      this.props.sendingAllData(this.state);
      if (this.props.type === "IMPORTER") {
        if (tempShipmentArr.length || tempWeightArr.length || tempTeuArr.length || tempValueArr.length) {
          this.props.callingPendoEvent(trackingEventDictionary.uniqueImportersTabFilterByApply);
        }
      } else {
        if (tempShipmentArr.length || tempWeightArr.length || tempTeuArr.length || tempValueArr.length) {
          this.props.callingPendoEvent(trackingEventDictionary.uniqueExportersTabFilterByApply);
        }
      }
    }, 100);

    if (input) {
      input.classList.remove("show");
      let val2 = document.getElementById("onClickClear");
      val2.classList.remove("show");
    }
  };
  setTotalFilterCount() {
    let tempCount = 0;
    if (this.state.filterAppliedShipment === true) {
      tempCount = tempCount + 1;
    }
    if (this.state.filterAppliedTeu === true) {
      tempCount = tempCount + 1;
    }
    if (this.state.filterAppliedWeight === true) {
      tempCount = tempCount + 1;
    }
    if (this.state.filterAppliedValue === true) {
      tempCount = tempCount + 1;
    }
    this.setState({
      count: tempCount,
    });
  }
  checkVisiblity = () => {
    if (this.props && this.props.internalFilterList && this.props.internalFilterList.length) {
      this.props.internalFilterList.map((item) => {
        if (item.isVisible) {
          if (item.key === "uniqueImportExporterShipment" && !this.props.hideShipment) this.setState({ isShipmentVisible: true });
          if (item.key === "uniqueImportExporterWeight" && !this.props.hideWeight) this.setState({ isWeightVisible: true });
          if (item.key === "uniqueImportExporterTeu" && !this.props.hideTeu) this.setState({ isTeuVisible: true });
          if (item.key === "uniqueImportExporterValue" && !this.props.hideValue) this.setState({ isValueVisible: true });
        }
      });
    } else {
      if (!this.props.hideShipment) this.setState({ isShipmentVisible: true });
      if (!this.props.hideWeight) this.setState({ isWeightVisible: true });
      if (!this.props.hideTeu) this.setState({ isTeuVisible: true });
      if (!this.props.hideValue) this.setState({ isValueVisible: true });
    }
  };

  setInputTypeHandler = (type, cb, value, placeholder) => {
    switch (type) {
      case "greater":
        return (
          <div className="tab-pane fade w-100" id={"pills-teu-greater-" + this.props.type} role="tabpanel" aria-labelledby={"pills-teu-greater-" + this.props.type}>
            <input type="number" className="w-100 form-control" placeholder={`Enter count of ${placeholder}`} value={value.max !== -1 ? value.max : <></>} onChange={(e) => cb(e.target.value, "min")} />
          </div>
        );
      case "between":
        return (
          <div className="input-group">
            <div className="px-3 w-50">
              <input type="number" className="form-control" placeholder="From" value={value.min !== -1 ? value.min : <></>} onChange={(e) => cb(e.target.value, "max")} />
            </div>
            <div className="px-3 w-50">
              <input type="number" className="form-control" placeholder="Upto" value={value.max !== -1 ? value.max : <></>} onChange={(e) => cb(e.target.value, "min")} />
            </div>
          </div>
        );
      default:
        return (
          <div className="tab-pane fade show active w-100" id={"pills-teu-less-" + this.props.type} role="tabpanel" aria-labelledby={"pills-teu-less-" + this.props.type}>
            <input type="number" className="w-100 form-control" placeholder={`Enter count of ${placeholder}`} value={value.min !== -1 ? value.min : <></>} onChange={(e) => cb(e.target.value, "max")} />
          </div>
        );
    }
  };

  setTabTypeHandler = (type, cb) => {
    return (
      <Card className="pill-card mb-3 cursor-pointer">
        <ul className="nav nav-pill  justify-content-between" id="shipment-tab-list" role="tablist">
          <li className="nav-item ">
            <p className={`nav-link m-0 ${type === "less" ? "active" : ""}`} id="pills-home-tab" data-toggle="pill" href={"#pills-home-" + this.props.type} role="tab" aria-controls={"pills-home-" + this.props.type} aria-selected="true" onClick={() => cb("less")}>
              less than
            </p>
          </li>
          <li className="nav-item ">
            <p className={`nav-link m-0 ${type === "between" ? "active" : ""}`} id="pills-profile-tab" data-toggle="pill" href={"#pills-profile-" + this.props.type} role="tab" aria-controls="pills-profile" aria-selected="false" onClick={() => cb("between")}>
              between
            </p>
          </li>
          <li className="nav-item ">
            <p className={`nav-link m-0 ${type === "greater" ? "active" : ""}`} id="pills-contact-tab" data-toggle="pill" href={"#pills-contact-" + this.props.type} role="tab" aria-controls="pills-contact" aria-selected="false" onClick={() => cb("greater")}>
              greater than
            </p>
          </li>
        </ul>
      </Card>
    );
  };

  render() {
    const { isOpen } = this.state;
    return (
      <div className="position-relative" id="onClickClear2" ref={this.dropdownRef}>
        <Button variant="secondaryWithIcon" size="small" className="tw-h-8 tw-font-medium tw-text-sm tw-flex tw-items-center disabled:tw-cursor-not-allowed" onClick={this.onClickHandler} id="dropdownMenuButton">
          <span className="filter-padding d-flex align-items-center">
            <span className="pr-1 tune-filter-by-tab-header material-symbols-outlined">tune</span>
            <span>Filter By</span>
          </span>
          {this.state.count > 0 && <span className="tw-flex tw-items-center tw-justify-center !tw-bg-primary-purple-100 !tw-text-primary-purple-600 mx-1 tw-py-0.5 tw-px-1.5 tw-border-none tw-rounded-2xl">{!!this && !!this.state && !!this.state.count && this.state.count !== 0 ? <span className="filter-no tw-text-xs tw-font-bold">{this.state.count}</span> : <></>}</span>}
        </Button>
        <div className={`tw-absolute tw-right-0 tw-z-20 tw-w-[250px] tw-border tw-rounded tw-mt-2 ${isOpen ? "" : "tw-hidden"}`} id="onClickClear">
          <Card className="trademo-filter-card">
            <Card.Header>
              <div className="d-flex">
                <div className="col p-0 filter-head" id="reacttourFilter">
                  Filter By Range
                </div>
                <div className="col-auto p-0 text-right">
                  {(!!this.state.uniqueImportExporterShipment && !!this.state.uniqueImportExporterShipment.length > 0) || (!!this.state.uniqueImportExporterTeu && !!this.state.uniqueImportExporterTeu.length > 0) || (!!this.state.uniqueImportExporterWeight && !!this.state.uniqueImportExporterWeight.length > 0) || (!!this.state.uniqueImportExporterValue && !!this.state.uniqueImportExporterValue.length > 0) ? (
                    <button type="button" className="btn btn-outline-secondary trademo-outline-btn btn-sm mx-1" onClick={(e) => this.resetValues(e)}>
                      Clear
                    </button>
                  ) : (
                    <></>
                  )}
                  {(!!this.state.filterAppliedShipment && this.state.filterAppliedShipment !== "") || (!!this.state.filterAppliedWeight && this.state.filterAppliedWeight !== "") || (!!this.state.filterAppliedTeu && this.state.filterAppliedTeu !== "") || (!!this.state.filterAppliedValue && this.state.filterAppliedValue !== "") ? (
                    <button type="button" className="btn btn-primary btn-sm trademo-new-btn" onClick={this.applyFilterFunction}>
                      Apply
                    </button>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </Card.Header>
            <Card.Body className="h-auto filter-card-body">
              <Accordion defaultActiveKey="0" className="trademo-filter-accordion">
                {!this.state.isShipmentVisible ? (
                  <></>
                ) : (
                  <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="0">
                      <div className="d-flex">
                        <span className="text-truncate" data-html={true}>
                          Shipments
                        </span>
                        <span className="toggle-up-show" />
                        <span className="tw-flex badge badge-pill badge-light green-filter-capsules mx-1 tw-p-0">
                          {this.state.uniqueImportExporterShipment.length > 0 ? (
                            <>
                              <span className="tw-inline-block tw-font-bold tw-leading-none tw-text-center tw-whitespace-nowrap tw-align-baseline tw-rounded filter-no tw-pl-1 tw-py-1 tw-text-xs">1</span>
                              <span className="badge tw-pr-1 tw-py-1">
                                <X size={14} color="#5A1CE2" className="cursor-pointer" onClick={(e) => this.clearIndividualFilter(e, filterKeywords.shipment)} />
                              </span>
                            </>
                          ) : (
                            <></>
                          )}
                        </span>
                        <ChevronDown size={16} color="#1a1722" className="ml-auto chevron-toggle-hide" />
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                      <Card.Body>
                        {this.setTabTypeHandler(this.state.shipmentType, (value) => this.displayShipment(value))}
                        {this.setInputTypeHandler(this.state.shipmentType, (value, type) => this.bindShipment(value, type), this.state.shipment, "Shipment")}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                )}
                {!this.state.isValueVisible ? (
                  <></>
                ) : (
                  <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="1">
                      <div className="d-flex">
                        <span className="text-truncate" data-html={true}>
                          Value
                        </span>
                        <span className="toggle-up-show" />
                        <span className="tw-flex badge badge-pill badge-light green-filter-capsules mx-1 tw-p-0">
                          {this.state.uniqueImportExporterValue.length > 0 ? (
                            <>
                              <span className="tw-inline-block tw-font-bold tw-leading-none tw-text-center tw-whitespace-nowrap tw-align-baseline tw-rounded filter-no tw-pl-1 tw-py-1 tw-text-xs">1</span>
                              <span className="badge tw-pr-1 tw-py-1">
                                <X size={14} color="#5A1CE2" className="cursor-pointer" onClick={(e) => this.clearIndividualFilter(e, filterKeywords.value)} />
                              </span>
                            </>
                          ) : (
                            <></>
                          )}
                        </span>
                        <ChevronDown size={16} color="#1a1722" className="ml-auto chevron-toggle-hide" />
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1">
                      <Card.Body>
                        {this.setTabTypeHandler(this.state.valueType, (value) => this.displayValue(value))}
                        {this.setInputTypeHandler(this.state.valueType, (value, type) => this.bindValue(value, type), this.state.value, "Value")}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                )}
                {!this.state.isTeuVisible ? (
                  <></>
                ) : (
                  <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="2">
                      <div className="d-flex">
                        <span className="text-truncate" data-html={true}>
                          TEU
                        </span>
                        <span className="toggle-up-show" />
                        <span className="tw-flex badge badge-pill badge-light green-filter-capsules mx-1 tw-p-0">
                          {this.state.uniqueImportExporterTeu.length > 0 ? (
                            <>
                              <span className="tw-inline-block tw-font-bold tw-leading-none tw-text-center tw-whitespace-nowrap tw-align-baseline tw-rounded filter-no tw-pl-1 tw-py-1 tw-text-xs">1</span>
                              <span className="badge tw-pr-1 tw-py-1">
                                <X size={14} color="#5A1CE2" className="cursor-pointer" onClick={(e) => this.clearIndividualFilter(e, filterKeywords.teu)} />
                              </span>
                            </>
                          ) : (
                            <></>
                          )}
                        </span>
                        <ChevronDown size={16} color="#1a1722" className="ml-auto chevron-toggle-hide" />
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="2">
                      <Card.Body>
                        {this.setTabTypeHandler(this.state.teuType, (value) => this.displayTeu(value))}
                        {this.setInputTypeHandler(this.state.teuType, (value, type) => this.bindTeu(value, type), this.state.teu, "Teu")}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                )}
                {!this.state.isWeightVisible ? (
                  <></>
                ) : (
                  <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="3">
                      <div className="d-flex">
                        <span className="text-truncate" data-html={true}>
                          Weight
                        </span>
                        <span className="toggle-up-show" />
                        <span className="tw-flex badge badge-pill badge-light green-filter-capsules mx-1 tw-p-0">
                          {this.state.uniqueImportExporterWeight.length > 0 ? (
                            <>
                              <span className="tw-inline-block tw-font-bold tw-leading-none tw-text-center tw-whitespace-nowrap tw-align-baseline tw-rounded filter-no tw-pl-1 tw-py-1 tw-text-xs">1</span>
                              <span className="badge tw-pr-1 tw-py-1">
                                <X size={14} color="#5A1CE2" className="cursor-pointer" onClick={(e) => this.clearIndividualFilter(e, filterKeywords.weight)} />
                              </span>
                            </>
                          ) : (
                            <></>
                          )}
                        </span>
                        <ChevronDown size={16} color="#1a1722" className="ml-auto chevron-toggle-hide" />
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="3">
                      <Card.Body>
                        {this.setTabTypeHandler(this.state.weightType, (value) => this.displayWeight(value))}
                        {this.setInputTypeHandler(this.state.weightType, (value, type) => this.bindWeight(value, type), this.state.weight, "Weight")}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                )}
              </Accordion>
            </Card.Body>
          </Card>
        </div>
      </div>
    );
  }
}
